import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = { class: "container p-4 text-left" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_9 = { class: "w-full px-2" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_13 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_14 = { class: "block mb-1" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_17 = { class: "block mb-1" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_20 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_21 = { class: "block mb-1" }
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_24 = { class: "block mb-1" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-5 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-6/12",
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-universal-access'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('titulo.editar.datos.personales')), 1)
                ]),
                _createVNode(_component_Form, {
                  "validation-schema": _ctx.schema,
                  onInvalidSubmit: _ctx.onInvalidSubmit
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.dni')), 1),
                          _createVNode(_component_Field, {
                            name: "dni",
                            modelValue: _ctx.formData.dni,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                                placeholder: _ctx.$t('label.dni')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(_component_ErrorMessage, { name: "dni" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('label.nombre')), 1),
                          _createVNode(_component_Field, {
                            name: "nombre",
                            modelValue: _ctx.formData.nombre,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                                placeholder: _ctx.$t('label.nombre')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_15, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('label.apellido')), 1),
                          _createVNode(_component_Field, {
                            name: "apellido",
                            modelValue: _ctx.formData.apellido,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                                placeholder: _ctx.$t('label.apellido')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_18, [
                                _createVNode(_component_ErrorMessage, { name: "apellido" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('label.cargo')), 1),
                          _createVNode(_component_Field, {
                            name: "cargo",
                            modelValue: _ctx.formData.cargo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.cargo) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                                placeholder: _ctx.$t('label.cargo')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_22, [
                                _createVNode(_component_ErrorMessage, { name: "cargo" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('label.telefono')), 1),
                          _createVNode(_component_Field, {
                            name: "telefono",
                            modelValue: _ctx.formData.telefono,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.telefono) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                                placeholder: _ctx.$t('label.telefono')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_25, [
                                _createVNode(_component_ErrorMessage, { name: "telefono" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onInvalidSubmit"]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.aplicarCambios && _ctx.aplicarCambios(...args))),
                    class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aplicar.cambios')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}